import { createAction } from 'typesafe-actions';

import { TemplateCenterActionType } from './actionTypes';
import type { GetTemplateCenterRequestPayload } from './types';

export const initializeTemplateCenterAction = createAction(
  TemplateCenterActionType.GET_TEMPLATE_CENTER_DATA_REQUEST
)<GetTemplateCenterRequestPayload>();
